<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('proyectos')">Proyecto:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.nombre}}
    </h1>
    <trashed-message v-if="proyecto.deleted_at" class="mb-6" @restore="restore">
     Proyecto Removed!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-4xl">
      <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap table-bordered">
        <tr class="border-t text-center font-bold">
           <th class="border-r px-6 pt-6 pb-4">Nº Man.  </th>
           <th class="border-r px-6 pt-6 pb-4">Nº Lote</th>
          <th class="border-r px-6 pt-6 pb-4">Proyecto</th>
          <th class="border-r px-6 pt-6 pb-4">Área</th>
          <th class="border-r px-6 pt-6 pb-4">Valor m2</th>
          <th class="border-r px-6 pt-6 pb-4">P.V.P</th>
          <th class="border-r px-6 pt-6 pb-4">Entrada</th>
          <th class="border-r px-6 pt-6 pb-4" >Tipo</th>
           <th class="border-r px-6 pt-6 pb-4" colspan="2">Estado</th>
          
        </tr>
        <tr v-for="lote in lotes" :key="lote.id" class="border-t items-center hover:bg-gray-100 focus-within:bg-gray-100">
           <td class="border-r px-6 py-4 flex items-center">
                {{ lote.Manzana }}
          
          </td>
          <td class="border-r px-6 py-4 items-center">
           
                {{ lote.Lote }}
          
          </td>
         <td class="border-r px-6 py-4 items-center">
           
                {{ lote.Proyecto }}
           
          </td>
           <td class="border-r px-6 py-4 items-center">
           
                {{ lote.TotalMetraje }}  m2 
           
          </td>
          <td class="border-r px-6 py-4 items-center">
           
           {{lote.MetrosConstruccion}}$
       
       </td>
          <td class="border-r px-6 py-4 items-center">
           
           {{lote.Total }}$
       
       </td>
       <td class="border-r px-6 py-4 items-center">
           
           {{lote.AreaConstruccion}}$
       
       </td>
        
          <td class="border-r px-6 py-4 items-center">
           
           {{lote.Bodega }}
       
       </td>
       <td class="border-r px-6 py-4 items-center">
           
           {{lote.Estado }}
       
       </td>
           <td class="border-r px-6 py-4 items-center">
           
              {{ lote.Predios }} 
            
          </td>
          
          <td>
            <inertia-link v-if="$page.props.auth.user.rol =='Admin'" class="btn-indigo" :href="route('proyectos.cotizar',lote.idLote)">
              <span class="hidden md:inline">Cotizar</span>
            </inertia-link>
             </td>
         
        </tr>
        <tr v-if="lotes.length === 0">
          <td class="border-r px-6 py-4 flex items-center" colspan="4">No se encontraron lotes</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="lotes.links" />
    </div>
    <br><br><br>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <text-input v-model="form.nombre" :error="form.errors.nombre" class="pr-6 pb-8 w-full lg:w-1/2" label="Nombre" />
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!proyecto.deleted_at && $page.props.auth.user.rol =='Admin'" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Proyecto</button>
          <loading-button :loading="form.processing" v-if="$page.props.auth.user.rol =='Admin'" class="btn-indigo ml-auto" type="submit">Guardar Proyecto</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Pagination from '@/Shared/Pagination'

export default {
  metaInfo() {
    return {
      title: `${this.form.nombre}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    Pagination,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    proyecto: Object,
    organizations: Array,
    lotes: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nombre: this.proyecto.nombre,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(this.route('proyectos.update', this.proyecto.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('proyectos.destroy', this.proyecto.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('proyectos.restore', this.proyecto.id))
      }
    },
  },
}
</script>
